import React, { useEffect, useState } from "react";
import api from "./api";
import AddPlaylistModal from "./AddPlaylistModal";
import DeletePlaylistModal from "./DeletePlaylistModal";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CryptoJS from "crypto-js";
import EnterPinModal from "./EnterPinModal";
import EditPlaylistModal from "./EditPlaylistModal";
import CouponActivateModal from "./CouponActivateModal";
import apiredeem from "./apiredeem";

const PlaylistPage = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isPinModalOpenEdit, setIsPinModalOpenEdit] = useState(false);
    const [playlistToDelete, setPlaylistToDelete] = useState(null);
    const [showEditModal, setShowEditModal] = useState(null);
    const [userList, setUserList] = useState([]);
    const [isXS, setIsXS] = useState(false);
    const [isPIN, setIsPIN] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [showPasswordModal, setShowPasswordModal] = useState(false);
    const [passwordInput, setPasswordInput] = useState('');
    const [pendingAction, setPendingAction] = useState(null); // { type: 'edit' | 'delete', profile: ... }
    const [activateModal, setActivateModal] = useState(false);
    const decryptPin = (encryptedPin) => {
        try {
            const bytes = CryptoJS.AES.decrypt(encryptedPin, 'OctadevIPTV');
            const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
            return decryptedData.pin; // Extract the actual PIN value
        } catch (error) {
            console.error("Decryption failed:", error);
            return null;
        }
    };


    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const [isPinModalOpen, setIsPinModalOpen] = useState(false);
    const [pin, setPin] = useState("");
    const [pinError, setPinError] = useState("");
    const [playlistToEdit, setPlaylistToEdit] = useState(null);
    const [profileToDelete, setProfileToDelete] = useState(null); // Added for password protected delete

    const device = JSON.parse(localStorage.getItem("deviceZplayer"));
    const password = JSON.parse(localStorage.getItem("deviceZplayerPass"));
    const mac = device.mac;
    const maceth = device.maceth;
    const [expired, setExpired] = useState(device.ExipiredAt);
    const isTerial = device.is_terial;
    const device_id = device.id;
    const status = device.status;
    const type = device.type;

    const compareDate = (date) => {
        return new Date(date) > new Date();
    };
    const fetchDeviceProfile = async () => {
        try {
            const response = await api.get(`profiles/${device_id}`);


            const result = response.data;
            if (result) {
                setUserList(result);
                console.clear();  // Clear the console for debugging visibility
            }
        } catch (error) {
            console.error("Error fetching device profile:", error);
        }
    };

    const fetchPlaylists = async () => { // Added fetchPlaylists for refresh
        try {
            const response = await api.get(`profiles/${device_id}`);
            setUserList(response.data);
        } catch (error) {
            console.error("Error fetching playlists:", error);
        }
    };

    const formatHost = (url) => {
        try {
            // Parse the URL to extract components
            const urlObj = new URL(url);
            const baseUrl = `${urlObj.protocol}//${urlObj.hostname}${urlObj.port ? ':' + urlObj.port : ''}`;

            // If it's an M3U playlist URL, show only the base URL
            if (url.includes('.m3u') || url.includes('get.php')) {
                return baseUrl;
            }

            // For Xtream URLs with parameters, mask credentials and remove unnecessary params
            let maskedUrl = url
                .replace(/(username=)[^&]+/, "$1****")
                .replace(/(password=)[^&]+/, "$1****")
                .replace(/&type=[^&]+/g, '') // Remove type parameter
                .replace(/&output=[^&]+/g, '') // Remove output parameter
                .replace(/&action=[^&]+/g, ''); // Remove action parameter

            // Limit the total length
            if (maskedUrl.length > 60) {
                return maskedUrl.substring(0, 57) + "...";
            }

            return maskedUrl;
        } catch (error) {
            // If URL parsing fails, fallback to simple truncation
            const cleanUrl = url
                .replace(/(username=)[^&]+/, "$1****")
                .replace(/(password=)[^&]+/, "$1****");

            return cleanUrl.length > 60 ? cleanUrl.substring(0, 57) + "..." : cleanUrl;
        }
    };
    useEffect(() => {
        fetchDeviceProfile()
    }, [])

    const handleSave = async (data) => {
        console.log("Saved Playlist:", data);

        try {
            const response = await api.post(`profiles`, { ...data, id_device: device_id });


            const result = response.data;
            if (!result.error) {
                setUserList([...userList, data]);
                //console.clear();  // Clear the console for debugging visibility
            }
        } catch (error) {
            console.error("Error fetching device profile:", error);
        }
    };
    const handleActivate = async (data) => {
        console.log("Activating Coupon:", data);


        try {
            // Send request to redeem coupon
            const response = await apiredeem.post("activate", {
                ...data,
                mac: device.mac,
            });

            if (!response.data.error) {
                if (response.data.ExipiredAt === expired) {

                    toast.error(`Vous devez entrer un code promo valide (\n ${response.data.message} )`);
                } else {

                    toast.success("Votre appareil est activé avec succès");

                    // Update user expiration date & status
                    setExpired(response.data.ExipiredAt);
                    const updatedUser = { ...device, ExipiredAt: response.data.ExipiredAt, status: 1 };
                    localStorage.setItem('deviceZplayer', JSON.stringify(updatedUser))


                }
            } else {
                toast.error(`Vous devez entrer un code promo valide (\n ${response.data.message} )`);
            }
        } catch (error) {
            console.error("Error activating device:", error);

        }
    };
    const handleSaveEdit = async (data) => {
        console.log("Saved Playlist:", data);

        try {
            const payload = { ...data, id_device: device_id };
            // Inject password if available
            if (passwordInput) {
                payload.required_password = passwordInput;
            }

            const response = await api.put(`profiles/${data.id}`, payload);


            const result = response.data;
            if (!result.error) {
                setUserList((prevUserList) =>
                    prevUserList.map((item) => (item.id === data.id ? { ...item, ...data } : item))
                );
                toast.success("Playlist updated successfully");
                setShowEditModal(false);
                setPasswordInput('');
                setPendingAction(null);
            }
        } catch (error) {
            if (error.response && error.response.data && error.response.data.message) {
                toast.error(error.response.data.message);
            } else {
                toast.error("Failed to update playlist");
            }
        }
    };


    const formattedExpiration = expired ? new Date(expired).toLocaleString() : '';
    // Handle the delete action (this is where you would trigger the API or other deletion logic)
    const deletePlaylist = async () => {
        try {
            const response = await api.delete(`profiles/${playlistToDelete.id}`);
            const result = response.data;
            if (!result.error) {
                setUserList(userList.filter(user => user.id !== playlistToDelete.id));
                toast.success("Playlist deleted successfully!");
            }
        } catch (error) {
            console.error("Error deleting profile:", error);
        }
        closeModals();
    };

    const openDeleteModal = (playlist) => {
        setPlaylistToDelete(playlist);
        if (playlist.pin) {
            setIsPinModalOpen(true);
        } else {
            setIsDeleteModalOpen(true);
        }
    };

    const confirmPin = () => {

        const pin2 = decryptPin(playlistToDelete?.pin);

        if (pin !== pin2) {
            setPinError("Incorrect PIN entered!");
            toast.error("Incorrect PIN!");
            return;
        }
        setIsPinModalOpen(false);
        setIsDeleteModalOpen(true);
    };

    const closeModals = () => {
        setIsPinModalOpen(false);
        setIsDeleteModalOpen(false);
        setPlaylistToDelete(null);
        setPin("");
        setPinError("");
    };
    const openEditModal = (playlist) => {
        if (playlist.pin) {
            setPlaylistToEdit(playlist);
            setIsPinModalOpenEdit(true);
        } else {
            setPlaylistToEdit(playlist);
            setShowEditModal(true);
        }
    };

    const confirmEdit = () => {
        setShowEditModal(true);
    };
    const confirmdelete = () => {
        setIsDeleteModalOpen(true);
    };

    const openDeleteModalWithPassword = (profile) => { // Renamed to avoid conflict with existing openDeleteModal
        setProfileToDelete(profile);
        if (profile.has_password) {
            setPendingAction({ type: 'delete', profile });
            setShowPasswordModal(true);
        } else {
            setShowDeleteModal(true);
        }
    };

    const confirmDelete = async () => {
        if (!profileToDelete) return;

        // If password was required, it should be passed via query param or body depending on API.
        // Based on my backend update: delete expects query param `required_password`
        let passwordQuery = '';
        if (pendingAction && pendingAction.type === 'delete' && passwordInput) {
            passwordQuery = `?required_password=${encodeURIComponent(passwordInput)}`;
        }

        try {
            await api.delete(`profiles/${profileToDelete.id}${passwordQuery}`);
            toast.success("Playlist deleted successfully");
            fetchPlaylists();
            setShowDeleteModal(false);
            setProfileToDelete(null);
            setPendingAction(null);
            setPasswordInput('');
        } catch (error) {
            // Handle error message from backend
            if (error.response && error.response.data && error.response.data.message) {
                toast.error(error.response.data.message);
            } else {
                toast.error("Failed to delete playlist");
            }
        }
    };

    // Prompt for password logic
    const handlePasswordSubmit = () => {
        setShowPasswordModal(false);
        if (pendingAction) {
            if (pendingAction.type === 'delete') {
                setShowDeleteModal(true);
                // We keep passwordInput in state to use it in confirmDelete
            } else if (pendingAction.type === 'edit') {
                setPlaylistToEdit(pendingAction.profile); // Use setPlaylistToEdit for consistency
                setShowEditModal(true);
                // We kept passwordInput, we will use it in edit submit
            }
        }
    };

    const openEditModalWithPassword = (profile) => { // Renamed to avoid conflict with existing openEditModal
        if (profile.has_password) {
            setPendingAction({ type: 'edit', profile });
            setShowPasswordModal(true);
        } else {
            setPlaylistToEdit(profile);
            setShowEditModal(true);
        }
    };

    const handleLogout = () => {
        // Clear user session (modify as needed)
        localStorage.removeItem("deviceZplayer");
        sessionStorage.removeItem("authTokenZplayer");

        // Redirect or refresh
        window.location.href = "/login";  // Redirect to login page
    };
    return (
        <section id="login"
            className="section contactus-section bg-container-login d-flex   justify-content-center min-vh-100">
            <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} />
            <div className="container w-100">
                <div className="card-container">
                    <div className="flex-container2">
                        <button className="logout-button" onClick={handleLogout}><i className="fas fa-sign-out"></i> Logout     </button>
                    </div>
                    <div className="flex-container">
                        <div className="avatar-container">
                            <>
                                {type === 1 && (
                                    <img className="avatar" src="/icon/android.png" alt="Type 1" />
                                )}
                                {type === 2 && (
                                    <img className="avatar" src="/icon/androidtv.png" alt="Type 2" />
                                )}
                                {type === 3 && (
                                    <img className="avatar" src="/icon/samsung.png" alt="Type 3" />
                                )}
                                {type === 4 && (
                                    <img className="avatar" src="/icon/webos.png" alt="Type 4" />
                                )}
                                {type === 5 && (
                                    <img className="avatar" src="/icon/fire-tv.png" alt="Type 5" />
                                )}
                            </>
                        </div>

                        <div className="info-container">
                            <div className="mac-address">
                                <i className="fas fa-wifi"></i> {/* Wi-Fi icon */}
                                {mac}
                            </div>
                            {maceth && (
                                <div className="mac-eth-address">
                                    <i className="fas fa-plug"></i> {/* RJ45 (Ethernet) cable icon */}
                                    {maceth}
                                </div>
                            )}
                            <div className="status-container">
                                <div className="status">
                                    <p>
                                        {status === 0 && compareDate(expired) && (
                                            <span className="text-warning">Testing Version</span>
                                        )}
                                        {status === 0 && !compareDate(expired) && (
                                            <span className="text-info">Expired Trial</span>
                                        )}
                                        {status === 1 && !compareDate(expired) && (
                                            <span className="text-danger">Expired</span>
                                        )}
                                        {status === 1 && compareDate(expired) && (
                                            <span className="text-success">Actived Device</span>
                                        )}

                                        <span style={{ display: "block" }}>   <b>Expiration:</b> {formattedExpiration}   </span>
                                    </p>
                                </div>

                            </div>


                        </div>

                    </div>
                    <div className="action-buttons ">
                        <button className="action-button mx-2" onClick={() => setActivateModal(true)}>
                            Activation coupon
                        </button>
                        <button className="action-button mx-2" onClick={() => setShowModal(true)}>
                            Add Playlist
                        </button>
                    </div>

                    <div className="content-container">
                        <div className="user-list">
                            {userList?.map((user, index) => (
                                <div key={index} className="user-card">

                                    <div className="user-content">
                                        <h3 className="user-title">{user.profile_name}</h3>

                                        <div className="user-host-section">
                                            {user.can_edit !== false &&
                                                <p className="user-host" title={user.host}>
                                                    <strong>Host:</strong>
                                                    <span className="host-url">{formatHost(user.host)}</span>
                                                </p>
                                            }


                                        </div>
                                        <div className="user-actions">
                                            {user.can_edit !== false && (
                                                <button className="btn btn-primary" onClick={() => openEditModalWithPassword(user)}>
                                                    ✏️ Edit
                                                </button>
                                            )}

                                            <button className="btn btn-danger" onClick={() => openDeleteModalWithPassword(user)}>
                                                🗑️ Delete
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                    {showModal && (
                        <AddPlaylistModal
                            onClose={() => setShowModal(false)}
                            onSave={handleSave}
                        />
                    )}
                    {activateModal && (
                        <CouponActivateModal
                            onClose={() => setActivateModal(false)}
                            onSave={handleActivate}
                        />
                    )}

                    {/* Enter PIN Modal */}
                    {isPinModalOpenEdit && (
                        <EnterPinModal
                            isOpen={isPinModalOpenEdit}
                            title="Enter PIN to Edit Playlist"
                            onClose={() => setIsPinModalOpenEdit(false)}
                            onConfirm={confirmEdit}
                            storedEncryptedPin={playlistToEdit?.pin}
                        />
                    )}  {/* Enter PIN Modal */}
                    {isPinModalOpen && (
                        <EnterPinModal
                            isOpen={isPinModalOpen}
                            title="Enter PIN to delete Playlist"
                            onClose={() => setIsPinModalOpen(false)}
                            onConfirm={confirmdelete}
                            storedEncryptedPin={playlistToEdit?.pin}
                        />
                    )}
                    {/* Delete Confirmation Modal */}
                    {isDeleteModalOpen && (
                        <DeletePlaylistModal
                            isOpen={isDeleteModalOpen}
                            onClose={closeModals}
                            onDelete={deletePlaylist}
                            playlistName={playlistToDelete?.profile_name}
                        />
                    )}
                    {/* Edit Playlist Modal */}
                    {showEditModal && (
                        <EditPlaylistModal
                            playlist={playlistToEdit}
                            onSave={handleSaveEdit}
                            onClose={() => setShowEditModal(false)}
                        />
                    )}
                </div>
            </div>

            {/* New Delete Confirmation Modal for password protected playlists */}
            {showDeleteModal && (
                <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Confirm Delete</h5>
                                <button type="button" className="btn-close" onClick={() => setShowDeleteModal(false)}></button>
                            </div>
                            <div className="modal-body">
                                Are you sure you want to delete the playlist "<b>{profileToDelete?.profile_name}</b>"?
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={() => setShowDeleteModal(false)}>Cancel</button>
                                <button type="button" className="btn btn-danger" onClick={confirmDelete}>Delete</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Password Modal */}
            {showPasswordModal && (
                <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Enter Password</h5>
                                <button type="button" className="btn-close" onClick={() => { setShowPasswordModal(false); setPendingAction(null); setPasswordInput(''); }}></button>
                            </div>
                            <div className="modal-body">
                                <div className="mb-3">
                                    <label className="form-label">Management Password</label>
                                    <input
                                        type="password"
                                        className="form-control"
                                        value={passwordInput}
                                        onChange={(e) => setPasswordInput(e.target.value)}
                                        placeholder="Enter password..."
                                    />
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={() => { setShowPasswordModal(false); setPendingAction(null); setPasswordInput(''); }}>Cancel</button>
                                <button type="button" className="btn btn-primary" onClick={handlePasswordSubmit}>Continue</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </section>
    );
};

export default PlaylistPage;
